module.exports = __webpack_public_path__ + "static/media/twitterIcon.db25aa6d.svg";